import { audioCtx } from "util/audioContext";
import { EQPlaybackControls } from "../../types";
import { InternalNodeState } from "./types";

export default function generateInternalNodeState(
  orderedFrequencies: number[],
  eq: EQPlaybackControls,
  startTime: number
): InternalNodeState[] {
  const newInternalNodeState: InternalNodeState[] = [];

  orderedFrequencies.forEach((freq, i) => {
    const { frequency, q, type, gain } = eq[freq];

    const node = audioCtx().createBiquadFilter();
    node.type = type;
    node.frequency.setValueAtTime(frequency, startTime);
    node.Q.setValueAtTime(q, startTime);
    node.gain.setValueAtTime(gain, startTime);

    // connect all nodes with the previous node but not to the input or output
    if (newInternalNodeState[i - 1]) {
      newInternalNodeState[i - 1].node.connect(node);
    }

    newInternalNodeState.push({ freq, node });
  });

  return newInternalNodeState;
}
